import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import { NewsEvent } from "../../../../components/modules/news/news-event";
import NewsEventMiddleware from "../../../../middleware/modules/news/news-event";
import i18n from "../../../../i18n";
import { Helmet } from "react-helmet";
// middlewares
const mapStateToProps = ({ auth, newsEvent }) => ({
  isProcessing: newsEvent.isProcessing,
  isError: newsEvent.isError,
  errorMessage: newsEvent.errorMessage,
  datalist: newsEvent.data,
  showModal: newsEvent.showModal,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      cancel: (id, value, search) => NewsEventMiddleware.beforeCancel(id, value, search),
      create: () => NewsEventMiddleware.create(),
      reset: () => NewsEventMiddleware.resetList(),
      search: (data) => NewsEventMiddleware.list(data),
      update: (data) => NewsEventMiddleware.update(data),
      delete: (id, search) => NewsEventMiddleware.beforeDelete(id, search),
      getHelperFull: (id, search) =>
        NewsEventMiddleware.getHelperFull(id, search),
    },
    dispatch
  );
};
class NewsEventContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  constructor(props) {
    super(props);
    this.deleteItem = this.deleteItem.bind(this);
    this.createItem = this.createItem.bind(this);
    this.updateItem = this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    this.props.search(search);
  }
  updateItem(id) {
    this.props.getHelperFull();
    this.props.update(id);
  }
  createItem() {
    this.props.create();
    this.props.getHelperFull();
  }
  deleteItem(id, value, search) {
    this.props.delete(id, value, search);
  }
  render() {
    const { isProcessing, search, datalist, showModal } = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("News Event List")}
          </title>
        </Helmet>
      <NewsEvent
        search={search}
        data={datalist}
        isProcessing={isProcessing}
        showModal={showModal}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewsEventContainer);
